export const TOKEN_AUTH_USERNAME = 'irrimetclient';
export const TOKEN_AUTH_PASSWORD = '_e84@0=6a5Z6f!4aETiz>c<+';
export const TOKEN_NAME = 'access_token';
export const InterceptorSkipHeader = 'X-Skip-Interceptor';
